var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkOriginal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 0H16C7.16344 0 0 7.16344 0 16V48C0 56.8366 7.16344 64 16 64H48C56.8366 64 64 56.8366 64 48V16C64 7.16344 56.8366 0 48 0Z",
    fill: "#008CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8133 23.6016C16.6417 17.3901 22.5133 12.8768 29.5017 12C26.5677 15.3485 24.4064 19.3107 23.1733 23.6016H13.8133ZM12.63 26.9609C12.21 28.6071 11.9983 30.3003 12 32C12 33.7402 12.2183 35.4282 12.63 37.0391H22.4133C21.857 33.7031 21.857 30.2969 22.4133 26.9609H12.63ZM25.8 26.9609C25.4875 28.6221 25.3313 30.3093 25.3333 32C25.3356 33.7245 25.4911 35.4042 25.8 37.0391H38.2C38.5067 35.4064 38.6667 33.7234 38.6667 32C38.6687 30.3093 38.5125 28.6221 38.2 26.9609H25.8ZM41.585 26.9609C42.1413 30.2969 42.1413 33.7031 41.585 37.0391H51.37C51.79 35.3929 52.0017 33.6997 52 32C52 30.2598 51.7817 28.5718 51.37 26.9609H41.585ZM50.1867 23.6016H40.8267C39.5941 19.3109 37.4334 15.3487 34.5 12C41.49 12.8768 47.3583 17.3901 50.1867 23.6016ZM50.1867 40.3984H40.8283C39.5947 44.6894 37.4329 48.6516 34.4983 52C41.4883 51.1232 47.3583 46.6099 50.1867 40.3984ZM37.3383 40.3984H26.6617C27.7924 43.8565 29.6086 47.0469 32 49.7761C34.3914 47.0469 36.2076 43.8565 37.3383 40.3984ZM23.1717 40.3984H13.8133C16.6417 46.6099 22.5133 51.1232 29.5017 52C26.5677 48.6515 24.4064 44.6893 23.1733 40.3984H23.1717ZM37.3383 23.6016H26.6617C27.7924 20.1435 29.6086 16.9531 32 14.2239C34.3914 16.9531 36.2076 20.1435 37.3383 23.6016Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkOriginal);
export default __webpack_public_path__ + "static/media/link_original.bff1e250b7c0969d39f91962eb3e1d85.svg";
export { ForwardRef as ReactComponent };